/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { GET_MARKET_STATUS } from 'pages/ApplicationUI/ApplicationUIGraphQL';
import { FREEZE_STATUS } from 'pages/ApplicationUI/constant';
import FSBModal from 'components/common/FSBModal';
import Loader from 'components/common/Loader';
import ErrorMessage from 'components/ErrorMessage';
import MarketFreezeDetail from './components/MarketFreezeDetail';
import MarketFreezeSchedule from '../MarketFreezeSchedule';

const MarketFreeze = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [toggleSwitch, setToggleSwitch] = useState(false);
  const { data, loading, error, refetch } = useQuery(GET_MARKET_STATUS, {
    variables: {
      filter: [
        {
          key: 'freezeStatus',
          value: 'true',
          type: 'BOOLEAN',
          op: 'EQ',
        },
      ],
    },
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    setToggleSwitch(
      data?.getMarketStatus?.applicationFreezeStatuses?.[0]?.freezeStatus,
    );
  }, [data?.getMarketStatus?.applicationFreezeStatuses?.[0]?.freezeStatus]);

  useEffect(() => {
    const handleScheduleUpdate = () => {
      refetch();
    };

    if (typeof window !== 'undefined') {
      window.addEventListener(
        'market-freeze-schedule-updated',
        handleScheduleUpdate,
      );
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener(
          'market-freeze-schedule-updated',
          handleScheduleUpdate,
        );
      }
    };
  }, [refetch]);

  useEffect(() => {
    const msUntilNextMinute = () => {
      const now = new Date();
      return ((60 - now.getSeconds()) * 1000) - now.getMilliseconds();
    };

    let intervalId;
    const timeoutId = setTimeout(() => {
      refetch();
      intervalId = setInterval(() => {
        refetch();
      }, 60000);
    }, msUntilNextMinute());

    return () => {
      clearTimeout(timeoutId);
      if (intervalId) clearInterval(intervalId);
    };
  }, [refetch]);

  const drawerToggle = () => {
    setIsDrawerOpen(!isDrawerOpen);
    setToggleSwitch(!toggleSwitch);
  };

  if (loading) return <Loader />;
  if (error) {
    return <ErrorMessage error={error} />;
  }
  if (!data?.getMarketStatus?.applicationFreezeStatuses)
    return 'Data not available';

  return (
    <div>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3">
        <div>
          <h4 className="f-18 fw-semibold mb-1">Market Freeze</h4>
        </div>
      </div>

      <div className="border rounded-3 p-3 bg-white">
        <h5 className="mb-2">
          Currently Market is{' '}
          {data?.getMarketStatus?.applicationFreezeStatuses?.[0]?.freezeStatus
            ? FREEZE_STATUS.FREEZE
            : FREEZE_STATUS.UNFREEZE}
        </h5>
        <div className="toggle-check text-start mt-2">
          <input
            type="checkbox"
            checked={toggleSwitch}
            onChange={() => {
              setToggleSwitch(!toggleSwitch);
              drawerToggle();
            }}
          />
        </div>
      </div>
      <FSBModal
        title="MarketFreeze"
        message=""
        open={isDrawerOpen}
        toggleAlert={drawerToggle}
        onClose={drawerToggle}
      >
      <MarketFreezeDetail
          refetch={refetch}
          drawerToggle={drawerToggle}
          initialValues={
            data?.getMarketStatus?.applicationFreezeStatuses.length
              ? data?.getMarketStatus?.applicationFreezeStatuses?.[0]
              : {}
          }
        />
      </FSBModal>
      <div className="mt-4">
        <MarketFreezeSchedule />
      </div>
    </div>
  );
};

export default MarketFreeze;
